// extracted by mini-css-extract-plugin
var _1 = "SingleEditor__SingleEditor--kv3Xy";
export { _1 as "SingleEditor" }
